import {
    GETMAPPINGDEALERLIST_SUCCESS,
    GETMAPPINGDEALERLIST_FAILED,
    RESET_GETMAPPINGDEALERLIST,
    LOADING_GETMAPPINGDEALERLIST,
    NETWORK_ERROR_GETMAPPINGDEALERLIST
} from "../types/index";

import { partnerServices } from "../../config/axios";


const resetGetDealerMappingListForPartner = () => {
    return { type: RESET_GETMAPPINGDEALERLIST };
};

const partnerGetDealerMappingListReq = (userData, authTokenIs) => async (dispatch) => {
    dispatch({ type: LOADING_GETMAPPINGDEALERLIST });
    await partnerServices
        .post("getMappingDealerList", userData, { headers: { AuthToken: authTokenIs } })
        .then((res) => {
            switch (res.data.status) {
                case "success":
                    dispatch(partnerGetMappingDealerListsuccess(res.data));
                    break;
                default:
                    dispatch(partnerGetMappingDealerListFailed(res.data));
                    break;
            }
        })
        .catch((err) => {
            dispatch({
                type: NETWORK_ERROR_GETMAPPINGDEALERLIST,
                payload: err
            });
        });
};

function partnerGetMappingDealerListsuccess(data) {
    return {
        type: GETMAPPINGDEALERLIST_SUCCESS,
        payload: data,
    };
}

function partnerGetMappingDealerListFailed(data) {
    return {
        type: GETMAPPINGDEALERLIST_FAILED,
        payload: data,
    };
}

export { resetGetDealerMappingListForPartner, partnerGetDealerMappingListReq }